import React from 'react'
import PropTypes from 'prop-types'
import * as S from '../../config/accountSubscription'

class RadioInput extends React.Component {
  constructor(props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(v) {
    this.props.onChange({
      stateProp: this.props.stateProp,
      value: v
    })
  }

  render() {
    const { value } = this.props
    const rows = []
    for (let i = 0; i < S.SUB_LENGTH; i++) {
      rows.push(
        <tr key={i} className={value === i ? 'ua-rad-con ua-rad-con-s' : 'ua-rad-con'} 
            onClick={() => this.handleChange(i)}>
          <td><input type='radio' value={i} name='subs' checked={value === i} readOnly /></td>
          <td>{S.getSubCount(i)}</td>
          <td>{S.getSubTotal(i)} Kč</td>
        </tr>
      )
    }
    return (
      <div className='ua-rads-con'>
        <table>
          <thead>
            <tr>
              <th></th>
              <th>Počet parcel</th>
              <th>Cena</th>
            </tr>
          </thead>
          <tbody>
            {rows}
          </tbody>
        </table>
      </div>
    )
  }
}

RadioInput.propTypes = {
  value: PropTypes.number,
  stateProp: PropTypes.string,
  onChange: PropTypes.func
}

export default RadioInput


// WEBPACK FOOTER //
// ./src/components/UserAccount/RegisterFormRadioInput.js